import axios from 'axios';
import React from 'react';
import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { useParams } from 'react-router-dom';

function LoginGoogle() {
    const queryParams = new URLSearchParams(window.location.search);
    const term = queryParams.get('token'); // Gets ?term=value
    console.log(term);

    const token = term;
    const decode = jwtDecode(token)

    localStorage.setItem("token", token);

    switch (decode.role) {
        case 0:
            window.location.href = '/super-usuario';
            break;
        case 1:
            window.location.href = '/administrador';
            break;
        case 2:
            window.location.href = '/invitador';
            break;
        case 3:
            window.location.href = '/proveedor';
            break;
        default: 
            window.location.href = '/';
            break;
    }
}

export default LoginGoogle;